<template>
  <div class="main-container">
    <div>
      <trainer-creator v-on:refresh-trainers="getTrainerList()" />
    </div>
    <div>
      <b-tabs content-class="mt-3" fill>
        <b-tab title="Персональні">
          <trainer-table v-bind:trainers="personal"></trainer-table>
        </b-tab>
        <b-tab title="Групові">
          <trainer-table v-bind:trainers="group"></trainer-table>
        </b-tab>
        <b-tab title="Масажисти">
          <trainer-table v-bind:trainers="massage"></trainer-table>
        </b-tab>
        <b-tab title="Інші співробітники">
          <trainer-table v-bind:trainers="other"></trainer-table>
        </b-tab>
      </b-tabs>
    </div>
    <trainer-view />
  </div>
</template>

<script>
import TrainerCreator from "@/components/modals/TrainerCreator";
import TrainerTable from "@/components/tables/TrainerTable";
import TrainerView from "@/components/modals/TrainerView";
import { mapActions, mapState } from "vuex";
export default {
  name: "Trainers",
  components: {
    TrainerCreator,
    TrainerTable,
    TrainerView,
  },
  data: function () {
    return {};
  },
  computed: {
    ...mapState(["trainers"]),
    personal: function () {
      return this.trainers.filter((trainer) => {
        return trainer.training_type === 1;
      });
    },
    group: function () {
      return this.trainers.filter((trainer) => {
        return trainer.training_type === 2;
      });
    },
    massage: function () {
      return this.trainers.filter((trainer) => {
        return trainer.training_type === 3;
      });
    },
    other: function () {
      return this.trainers.filter((trainer) => {
        return trainer.training_type === 4;
      });
    },
  },
  async mounted() {
    await this.getTrainerList();
  },
  methods: {
    ...mapActions(["setClubTrainers", "logOutUser"]),
    async getTrainerList() {
      let trainers = await this.$api.trainers.getTrainersList();
      await this.setClubTrainers(trainers.data);
    },
  },
};
</script>

<style scoped></style>
